/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/23
 * @updateTime 2021/8/23
 * @decription 变更担保-表单
 */
import {columnsDBBGSX, columnsDBFS} from "@/utils/option";
import {
    // 变更原因
    bgdbyyRule,
    dbfsRule,
    DbjzRule,
    bgdbsxRule,
    bgdbsqsRule,
    xgclRule
} from "@/utils/validator/rules";
import validate from "@/utils/validator/validator";
// 表单处理js
import formHandler from '../mixins/formHandler.js';

export default {
    name: 'app-modify-dbxx',
    // 混入
    mixins: [formHandler],
    components: {},
    props: {
        // 原始数据
        originData: Object
    },
    data() {
        return {
            // 私有变量
            scope: {
                // class前缀
                prefixCls: 'fd-modify-dbxx'
            },
            formData: {
                // 如果是新增进入页面调用接口生成，否则从data中获取
                cId: '',
                // 之前的担保id
                bGhid: '',
                // 变更担保原因
                cSqbgyy: '',
                // 变更担保事项
                nBgsxlx: 2,
                // 变更担保事项文本
                cBgsxlxText: '申请变更担保',
                // 诉责险id，担保方式为诉责险并且是系统自动关联中表单提交的时候会用到
                cSzxid: '',
                // 担保机构id
                cBxgs: '',
                // 担保机构文字描述
                cBxgsText: '',
                // 保单号
                bdh: '',
                // 担保价值
                nDbjz: '',
                // 担保价值文本
                nDbjzText: '',
                // 担保价值
                cDbsm: '',
                // 担保方式
                cDbfs: columnsDBFS[0].keyId,
                // 担保方式文字描述
                dbfsText: columnsDBFS[0].text,
                // 担保人
                cDbr: '',
                // 担保物名称
                cDbwmc: '',
                // 抵押/质押财产类型,
                cCclx: '',
                // 财产类型文字描述
                cCclxText: '',
                // 是否编辑过
                isEdit: true,
                // 申请书材料
                applicationFiles: [],
                // 相关材料
                relatedFiles: []
            },
            // 变更担保事项
            showPickerBgdbsx: false
        };
    },
    computed: {
        columnsDBBGSX() {
            // 当前数据是否可以减少，如果可以，则直接返回对应的数组
            // 如果不可以，则不显示申请减少担保，担保方式为5保险诉责险并且是系统关联的 不能进行申请减少担保
            if (this.data.noReduce) {
                return columnsDBBGSX.filter(item => {
                    return item.keyId !== 1;
                });
            }
            return columnsDBBGSX;
        },

        // 上传文件参数
        uploadFileParam() {
            return {
                // 保全id
                bqid: this.bqid,
                // 担保id
                dbid: this.formData.bGhid,
                tjid: '',
                // 材料类型
                cllx: '4',
                sqslx: '4'
            };
        },

        /**
         * 变更担保申请书材料上传参数
         * */
        applyUploadParam() {
            return {
                ...this.uploadFileParam,
                cllx: 1,
                sqslx: '301'
            };
        },

        /**
         * 减少担保的时候 很多是只读的
         * */
        readonly() {
            return this.formData.nBgsxlx === 1;
        }
    },
    methods: {

        /**
         * 获取删除文件的参数
         * @param {Object} fileData 文件数据
         * @returns {Object} 请求参数对象
         * */
        getDeleteFileParam(fileData) {
            return {
                // 请求id
                id: fileData.id,
                // 材料类型
                cllx: fileData.cllx
            }
        },

        /**
         * 获取相关文件数据
         * */
        getRelatedFileData(data, fileData) {
            return {
                // 插件自带的数据
                ...fileData,
                // 材料id
                id: data.fileId,
                // 名称
                name: data.filename,
                // 材料类型
                cllx: this.uploadFileParam.cllx
            };
        },

        /**
         * 获取申请文件数据
         * */
        getApplyFileData(data, fileData) {
            return {
                // 插件自带的数据
                ...fileData,
                // 材料id
                id: data.fileId,
                // 名称
                name: data.filename,
                // 材料类型
                cllx: this.applyUploadParam.cllx
            };
        },

        /**
         * 确认担保变更事项
         * @param {Object} item 选择的信息项
         * @returns {void}
         * */
        onConfirmBgdbsx: function (item) {
            // 如果选择的值相同，则直接关闭弹层
            if (item.keyId === this.formData.nBgsxlx) {
                this.showPickerBgdbsx = false;
                return;
            }
            this.deleteFiles();
            // 申请减少担保
            if (item.keyId === 1) {
                // 重新组装表单数据
                this.commonAssembleFormData(this.originData);
            }
            // 变更事项文本
            this.formData.cBgsxlxText = item.text;
            // 变更事项类型
            this.formData.nBgsxlx = item.keyId;
            this.showPickerBgdbsx = false;
        },

        /**
         * 删除相关材料
         * @returns {void}
         * */
        deleteFiles() {
            // 调用删除变更担保申请材料接口
            this.requestDelSccl({
                cDbid: this.formData.bGhid,
                isDeldbl: true,
                isDelsqs: true,
                cBgid: ''
            }).then(() => {
                // 相关材料置空
                this.formData.relatedFiles = [];
                // 变更申请书材料置空
                this.formData.applicationFiles = [];
            }).catch(error => {
                console.log(error);
            });
        },

        /**
         * 校验表单数据
         * */
        validateFormDate: function () {
            var descriptor = {
                // 担保原因
                cSqbgyy: bgdbyyRule,
                // 变更担保事项
                nBgsxlx: bgdbsxRule,

            };
            // 变更担保事项
            switch (String(this.formData.nBgsxlx)) {
                case '1':
                    // 减少担保 时担保方式一定是交纳保证金
                    descriptor.cDbfs = dbfsRule;
                    // 担保价值
                    descriptor.nDbjz = new DbjzRule(true);
                    // 相关材料
                    descriptor.relatedFiles = xgclRule;
                    break;
                case '2':
                    // 公共表单校验
                    this.commonValidateForm(descriptor);
                    // 如果是非保险公司诉责险并且自动关联，则相关材料必填
                    if (!(this.formData.cDbfs == 5 && this.formData.nSysbuy === 1)) {
                        // 相关材料
                        descriptor.relatedFiles = xgclRule;
                    }
                    break;
                case '3':
                    // 取消担保
                    break;
            }
            // 变更担保申请书
            descriptor.applicationFiles = bgdbsqsRule;
            // 校验表单数据
            const validated = validate(descriptor, this.formData);
            return validated;
        },

        /**
         * 将信息提交到父级组件
         */
        submitDBXX: function () {
            // 如果是取消担保，需要将担保方式还原回最原始的数据
            if (this.formData.nBgsxlx === 3) {
                this.formData = {
                    ...this.formData,
                    // 担保方式文本赋值
                    dbfsText: this.originData.dbfsText,
                    // 担保方式值赋值
                    cDbfs: this.originData.cDbfs,
                    // 担保机构置空
                    cBxgs: '',
                    // 担保机构名称置空
                    cBxgsmc: '',
                    // 保单号置空
                    cBdh: '',
                    // 担保价值
                    nDbjz: '',
                    // 担保价值文本
                    nDbjzText: '',
                    // 担保人
                    cDbr: '',
                    // 担保说明
                    cDbsm: '',
                    // 担保物名称
                    cDbwmc: '',
                    // 抵押/质押财产类型,
                    cCclx: '',
                    // 财产类型文字描述
                    cCclxText: '',
                    // 是否系统自动关联
                    nSysbuy: this.originData.nSysbuy
                };
            }
            // 进行保存
            this.$emit('submit', this.formData);
        },

        /**
         * 初始化数据
         * */
        initData() {
            // 申请人姓名通过url参数中获取
            let source = this.source;
            // 赋值申请人姓名
            this.sqr = source.sqrXm;
        },
        /**
         * 组装表单数据
         * @returns {void}
         * */
        assembleFormData() {
            // 公共组装个表单数据
            this.commonAssembleFormData();
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 初始化数据
            this.initData();
            // 组装表单数据
            this.assembleFormData();
        }
    },
    created() {
        // 初始化方法
        this.init();
    }
}
